import { Services } from '@sigma-frontend-libs/commons'
import { EContractsSignMethods } from '@sigmasms/shared-types'

import { labelModes, permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy() ],

  props: {
    labelMode: {
      type: String,
      default: labelModes.line
    }
  },

  computed: {
    canCreateContractsAsAdmin() {
      return this.checkPermissions(`advanced.${Services.contracts}.create`, permissionPresets.true)
    },

    canUpdateContractsAsAdmin() {
      return this.checkPermissions(`advanced.${Services.contracts}.update`, permissionPresets.true)
    },

    canSetSignMethod() {
      if (this.isNew) {
        return this.canCreateContractsAsAdmin
      }

      return this.canUpdateContractsAsAdmin
    },

    signMethodOptions() {
      const methods = [
        EContractsSignMethods.original,
        EContractsSignMethods['edo-diadok'],
        EContractsSignMethods['edo-sbis'],
        EContractsSignMethods.copy
      ]

      return methods.map(method => {
        return {
          title: this.getTranslate(`${Services.contracts}.signMethods.${method}`),
          value: method
        }
      })
    }
  },

  render
}
